import { z } from 'zod';
import {
  knowhowNoteSchema,
  knowhowNoteListItemSchema,
  upsertKnowhowNoteRequestSchema,
  type KnowhowNote,
  type KnowhowNoteListItem,
  type UpsertKnowhowNoteRequest,
} from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

const noteListSchema = z.array(knowhowNoteListItemSchema);

export class KnowhowNotesResource {
  constructor(private readonly http: HttpClient) {}

  list(opts?: { since?: string; signal?: AbortSignal }): Promise<KnowhowNoteListItem[]> {
    const params = opts?.since ? `?since=${encodeURIComponent(opts.since)}` : '';
    return this.http.request({
      method: 'GET',
      path: `/knowhow-notes${params}`,
      responseSchema: noteListSchema,
      signal: opts?.signal,
    });
  }

  get(id: string, signal?: AbortSignal): Promise<KnowhowNote> {
    return this.http.request({
      method: 'GET',
      path: `/knowhow-notes/${encodeURIComponent(id)}`,
      responseSchema: knowhowNoteSchema,
      signal,
    });
  }

  upsert(id: string, body: UpsertKnowhowNoteRequest, signal?: AbortSignal): Promise<KnowhowNote> {
    return this.http.request({
      method: 'PUT',
      path: `/knowhow-notes/${encodeURIComponent(id)}`,
      body: upsertKnowhowNoteRequestSchema.parse(body),
      responseSchema: knowhowNoteSchema,
      signal,
    });
  }

  delete(id: string, signal?: AbortSignal): Promise<void> {
    return this.http.request({
      method: 'DELETE',
      path: `/knowhow-notes/${encodeURIComponent(id)}`,
      expectEmpty: true,
      signal,
    });
  }
}
